import { HttpEventType } from '@angular/common/http';
import { Component, Optional } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { TypeDocumentEnums } from 'src/app/enum/type-document-enums';
import { TypePersonEnums } from 'src/app/enum/type-person-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ProviderImportModel } from 'src/app/models/imports/provider-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ProviderService } from 'src/app/services/archive/provider.service';
import { ValidateEmailService } from 'src/app/services/global-services/validate-email.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-provider',
  templateUrl: './import-provider.component.html',
  styleUrls: ['./import-provider.component.scss'],
  standalone: false
})
export class ImportProviderComponent {

  errorProvider: number = 0;
  eventFile: any
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  providerAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  providerImport: boolean = false;
  visibleTxt: boolean = false;

  constructor(private providerService: ProviderService,
    private toastHandlerService: ToastHandlerService,
    private validateEmailService: ValidateEmailService,
    @Optional() private ref: DynamicDialogRef) { }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.providerImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadGuideImport() {
    this.providerService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaProveedores.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.providerAlerts || this.providerAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.providerService.exportImportErrors(this.providerAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionProveedores_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importProviders() {
    this.providerAlerts = [];
    this.errorProvider = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<ProviderImportModel>();
    let row: ProviderImportModel;
    let column: string = '', counter: number = 1, typeDocumentId: number, documentNumber: string, digitVerification: number, typePersonId: number,
      names: string | null, lastNames: string | null, businessName: string, comercialName: string, email: string | null, phone: string,
      alterPhone: string | null, address: string, departmentCode: string, cityCode: string, rateDiscount: number, shopping: boolean,
      subRent: boolean, transport: boolean, currencyCode: string, expirationDays: number, swExpirationDays: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          "El archivo ingresado no tiene registros para importar."
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Tipo de Documento:
        column = 'A';
        if (element[0] as string != "N" && element[0] as string != "C" && element[0] as string != "E") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El tipo de documento debe ser valores como: 'N' / 'C' / 'E'.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }
        switch (element[0] as string) {
          case "N": {
            typeDocumentId = TypeDocumentEnums.nit;
            break;
          }
          case "C": {
            typeDocumentId = TypeDocumentEnums.cedula;
            break;
          }
          default: {
            typeDocumentId = TypeDocumentEnums.extranjeria;
            break;
          }
        }

        //B. Documento:
        documentNumber = element[1] as string;
        column = 'B';
        if (documentNumber == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El documento no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        } else if (documentNumber.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El documento supera el tamaño máximo de caracteres (15).`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        //C. Dígito de verificación:
        digitVerification = parseFloat(element[2] as string);
        column = 'C';
        if (isNaN(digitVerification) || digitVerification < 0 || digitVerification > 9) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El dígito de verificación no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        //D. Tipo de Persona:
        column = 'D';
        if (element[3] as string != "N" && element[3] as string != "J") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El tipo de persona debe ser valores como: N / J.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        typePersonId = element[3] as string === "N" ? TypePersonEnums.natural : TypePersonEnums.juridica;
        if (typePersonId == TypePersonEnums.juridica && typeDocumentId == TypeDocumentEnums.cedula) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El Proveedor tiene definido como Tipo Persona: JURÍDICA, el Tipo de Documento NO puede ser Ced.Ciudadanía.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }
        if (typePersonId == TypePersonEnums.natural && typeDocumentId == TypeDocumentEnums.nit) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El Proveedor tiene definido como Tipo Persona: NATURAL, el Tipo de Documento NO puede ser NIT.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        //E. Nombres, F. Apellidos y G. Razón Social:
        if (typePersonId == TypePersonEnums.natural) {
          names = element[4] as string;
          lastNames = element[5] as string;
          column = 'E o F';
          if (names == null || lastNames == null) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna ${column}. Los nombres o apellidos del Proveedor no son válidos.`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          } else if (names.length > 75 || lastNames.length > 75) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter},Columna ${column}. Los nombres o apellidos superan el tamaño máximo de caracteres (75).`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          }
          businessName = [names, lastNames].filter(Boolean).join(' ');
        } else {
          names = null;
          lastNames = null;
          businessName = element[6] as string;
          column = 'G';
          if (businessName == null) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna ${column}. La razón social del Proveedor no es válido.`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          } else if (businessName.length > 150) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna ${column}. La razón social supera el limite máximo de caracteres (150).`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //H. Nombre Comercial:
        comercialName = element[7] as string;
        column = 'H';
        if (comercialName != null) {
          if (comercialName.length > 100) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna ${column}. El Nombre Comercial supera el tamaño máximo de caracteres (100)`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          }
        }

        // I. E-mail:
        column = 'I';
        email = element[8] as string;
        if (email != null) {
          if (!this.validateEmailService.validateEmailsImport(email)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna ${column}. El e-mail del proveedor no es válido o supera el limite máximo de caracteres (250).`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          }
        }

        //J. Teléfono:
        phone = element[9] as string;
        column = 'J';
        if (isNaN(parseFloat(phone))) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El teléfono del Proveedor no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        } else if (phone.length < 7 || phone.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El teléfono del Proveedor no tiene una longitud válida.(7-15)`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        //K. Teléfono alterno
        alterPhone = element[10] as string;
        column = 'K';
        if (alterPhone != null) {
          if (alterPhone.length < 7 || alterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna ${column}. El teléfono alterno del Proveedor no tiene una longitud válida.(7-15)`;
            this.providerAlerts.push(alert);
            rowHasError = true;
          }
        }

        // L. Dirección:
        address = element[11] as string;
        column = 'L';
        if (address == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. La dirección del Proveedor no es válida.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        } else if (address.length > 70) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. La dirección del Proveedor supera el tamaño máximo de caracteres (70).`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        // M. Ciudad:
        cityCode = element[12] as string;
        column = 'M';
        if (cityCode == null || cityCode.length > 3) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El código de la ciudad no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        // N. Departamento:
        departmentCode = element[13] as string;
        column = 'N';
        if (departmentCode == null || departmentCode.length > 2) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El código del departamento no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        // O. Tarifa Descuento
        rateDiscount = element[14] as string != null ? parseFloat(element[14] as string) : 0;
        column = 'O';
        if (isNaN(rateDiscount)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El campo Tarifa Descuento no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        // P. Compras:
        column = 'P';
        if (element[15] as string != "S" && element[15] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El campo Compras debe ser valores como: S / N.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }
        shopping = element[15] as string === "S" ? true : false;

        // Q. Subalquiler
        column = 'Q';
        if (element[16] as string != "S" && element[16] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El campo Subalquiler debe ser valores como: S / N.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }
        subRent = element[16] as string === "S" ? true : false;

        // R. Transportador
        column = 'R';
        if (element[17] as string != "S" && element[17] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El campo Transportador debe ser valores como: S / N.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }
        transport = element[17] as string === "S" ? true : false;

        // S. Moneda (código):
        column = 'S';
        currencyCode = element[18] as string;
        if (currencyCode != null && currencyCode.length > 3) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El código de la moneda no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        // T. Días de Vencimiento:
        column = 'T';
        expirationDays = element[19] as string != null ? parseFloat(element[19] as string) : 0;
        if (isNaN(expirationDays) || expirationDays < 0 || expirationDays > 32767) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna ${column}. El campo Días de Vencimiento no es válido.`;
          this.providerAlerts.push(alert);
          rowHasError = true;
        }

        swExpirationDays = !isNaN(expirationDays) && expirationDays > 0;

        if (!rowHasError) {
          row = new ProviderImportModel(column, counter, typeDocumentId, documentNumber, digitVerification, typePersonId, names, lastNames, businessName,
            comercialName, email, phone, alterPhone, address, departmentCode, cityCode, rateDiscount, shopping, subRent, transport, currencyCode, expirationDays, swExpirationDays);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorProvider = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportProviders(rowsImports);
    });
  }

  async processImportProviders(rowsImports: Array<ProviderImportModel>) {
    try {
      const response = await firstValueFrom(this.providerService.importProviders(rowsImports));
      this.loadPreInvoicingModel = response;
      this.providerAlerts = response?.alerts ?? [];
      this.errorProvider = response?.preInvoicingStateId;

      if (this.errorProvider === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.providerAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.providerImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Proveedores.', error);
    }
  }
}